// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.information_wrapper__RwxED {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.information_body__ktAqi {
  background: #C7FF24;
  margin-bottom: 45px;
}

.information_phones__0ir-j {
  font-size: 0;
}

.information_column__3z3oU {
  margin: 0;
  padding: 0 0 0 2ch;
}
.information_column__3z3oU li {
  margin-top: 4px;
  font-size: 15px;
}

.information_priceData__V5QLt {
  margin-bottom: 40px;
}

.information_left__RT87I {
  max-width: 592px;
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  font-family: Inter;
}
.information_left__RT87I p {
  margin-top: 4px;
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
}
.information_left__RT87I span {
  color: #111827;
  font-weight: 500;
  font-size: 18px;
  margin-top: 40px;
  display: inline-block;
}
.information_left__RT87I h3 {
  line-height: 60px;
  font-size: 48px;
  letter-spacing: -1px;
  color: #111827;
}

.information_actions__72Wtl {
  display: flex;
  align-items: center;
  grid-gap: 12px;
  margin-top: 12px;
}

@media (max-width: 1170px) {
  .information_left__RT87I h3 {
    font-size: 42px;
    line-height: 52px;
  }
  .information_left__RT87I p {
    font-size: 16px;
  }
  .information_left__RT87I span {
    font-size: 16px;
  }
  .information_phones__0ir-j img {
    max-width: 100%;
    height: auto;
  }
}
@media (max-width: 1170px) {
  .information_left__RT87I h3 {
    font-size: 36px;
    line-height: 42px;
  }
  .information_left__RT87I p {
    font-size: 14px;
    line-height: 20px;
  }
  .information_left__RT87I span {
    font-size: 14px;
  }
}
@media (max-width: 860px) {
  .information_left__RT87I {
    max-width: 420px;
  }
}
@media (max-width: 830px) {
  .information_left__RT87I h3 {
    font-size: 28px;
    line-height: 34px;
  }
  .information_left__RT87I p {
    font-size: 14px;
  }
}
@media (max-width: 724px) {
  .information_left__RT87I {
    max-width: 350px;
  }
  .information_left__RT87I h3 {
    font-size: 26px;
    line-height: 30px;
  }
  .information_left__RT87I p {
    font-size: 13px;
  }
}
@media (max-width: 688px) {
  .information_body__ktAqi {
    padding: 40px 0;
  }
  .information_phones__0ir-j {
    display: none;
  }
}
@media (max-width: 430px) {
  .information_left__RT87I h3 {
    font-size: 36px;
    line-height: 45px;
  }
  .information_left__RT87I p {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/information/information.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AACF;;AAEA;EACE,mBAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,SAAA;EACA,kBAAA;AACF;AACE;EACE,eAAA;EACA,eAAA;AACJ;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;AAAF;AAEE;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAAJ;AAGE;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;AADJ;AAIE;EACE,iBAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;AAFJ;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AAHF;;AAKA;EAEI;IACE,eAAA;IACA,iBAAA;EAHJ;EAKE;IACE,eAAA;EAHJ;EAME;IACE,eAAA;EAJJ;EAQE;IACE,eAAA;IACA,YAAA;EANJ;AACF;AAWA;EAEI;IACE,eAAA;IACA,iBAAA;EAVJ;EAYE;IACE,eAAA;IACA,iBAAA;EAVJ;EAaE;IACE,eAAA;EAXJ;AACF;AAeA;EACE;IACE,gBAAA;EAbF;AACF;AAgBA;EAEI;IACE,eAAA;IACA,iBAAA;EAfJ;EAiBE;IACE,eAAA;EAfJ;AACF;AAmBA;EACE;IACE,gBAAA;EAjBF;EAkBE;IACE,eAAA;IACA,iBAAA;EAhBJ;EAkBE;IACE,eAAA;EAhBJ;AACF;AAoBA;EACE;IACE,eAAA;EAlBF;EAoBA;IACE,aAAA;EAlBF;AACF;AAqBA;EAEI;IACE,eAAA;IACA,iBAAA;EApBJ;EAsBE;IACE,eAAA;EApBJ;AACF","sourcesContent":[".wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.body {\r\n  background: #C7FF24;\r\n  margin-bottom: 45px;\r\n}\r\n\r\n.phones {\r\n  font-size: 0;\r\n}\r\n\r\n.column {\r\n  margin: 0;\r\n  padding: 0 0 0 2ch;\r\n  \r\n  li {\r\n    margin-top: 4px;\r\n    font-size: 15px;\r\n  }\r\n}\r\n\r\n.priceData {\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.left {\r\n  max-width: 592px;\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: flex-start;\r\n  flex-direction: column;\r\n  font-family: Inter;\r\n\r\n  p {\r\n    margin-top: 4px;\r\n    font-weight: 400;\r\n    font-size: 18px;\r\n    line-height: 28px;\r\n  }\r\n\r\n  span {\r\n    color: #111827;\r\n    font-weight: 500;\r\n    font-size: 18px;\r\n    margin-top: 40px;\r\n    display: inline-block;\r\n  }\r\n\r\n  h3 {\r\n    line-height: 60px;\r\n    font-size: 48px;\r\n    letter-spacing: -1px;\r\n    color: #111827;\r\n  }\r\n}\r\n\r\n.actions {\r\n  display: flex;\r\n  align-items: center;\r\n  grid-gap: 12px;\r\n  margin-top: 12px;\r\n}\r\n@media (max-width: 1170px) {\r\n  .left {\r\n    h3 {\r\n      font-size: 42px;\r\n      line-height: 52px;\r\n    }\r\n    p {\r\n      font-size: 16px;\r\n    }\r\n\r\n    span {\r\n      font-size: 16px;\r\n    }\r\n  }\r\n  .phones {\r\n    img {\r\n      max-width: 100%;\r\n      height: auto;\r\n    }\r\n  }\r\n\r\n}\r\n\r\n@media (max-width: 1170px) {\r\n  .left {\r\n    h3 {\r\n      font-size: 36px;\r\n      line-height: 42px;\r\n    }\r\n    p {\r\n      font-size: 14px;\r\n      line-height: 20px;\r\n    }\r\n\r\n    span {\r\n      font-size: 14px;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 860px) {\r\n  .left {\r\n    max-width: 420px;\r\n  }\r\n}\r\n\r\n@media (max-width: 830px) {\r\n  .left {\r\n    h3 {\r\n      font-size: 28px;\r\n      line-height: 34px;\r\n    }\r\n    p {\r\n      font-size: 14px;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 724px) {\r\n  .left {\r\n    max-width: 350px;\r\n    h3 {\r\n      font-size: 26px;\r\n      line-height: 30px;\r\n    }\r\n    p {\r\n      font-size: 13px;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 688px) {\r\n  .body {\r\n    padding: 40px 0;\r\n  }\r\n  .phones {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media (max-width: 430px) {\r\n  .left {\r\n    h3 {\r\n      font-size: 36px;\r\n      line-height: 45px;\r\n    }\r\n    p {\r\n      font-size: 16px;\r\n    }\r\n  }\r\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `information_wrapper__RwxED`,
	"body": `information_body__ktAqi`,
	"phones": `information_phones__0ir-j`,
	"column": `information_column__3z3oU`,
	"priceData": `information_priceData__V5QLt`,
	"left": `information_left__RT87I`,
	"actions": `information_actions__72Wtl`
};
export default ___CSS_LOADER_EXPORT___;
